export const tarimHayvancilikPage = () => `
  <section class="page-content service-page">
    <div class="container">
      <div class="service-header">
        <h1 class="page-title">Tarım ve Hayvancılık Sigortaları</h1>
        <p class="page-subtitle">Devlet destekli TARSİM sigortaları ile ürünlerinizi, hayvanlarınızı ve seralarınızı doğal risklere karşı koruyoruz.</p>
      </div>

      <div class="service-list">
        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M12 22c-4.97 0-9-2.24-9-5v-4c0-2.76 4.03-5 9-5s9 2.24 9 5v4c0 2.76-4.03 5-9 5z"></path><path d="M12 8V2"></path><path d="M8 4l4-2 4 2"></path></svg>
          </div>
          <div class="service-info">
            <h3>TARSİM (Devlet Destekli Tarım Sigortası)</h3>
            <p>Bitkisel ürünlerinizi dolu, don, sel, kuraklık ve fırtına gibi doğal afetlere karşı devlet destekli prim indirimi ile sigortalayın. Prim tutarının %50'sine kadar devlet desteği sağlanmaktadır.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line></svg>
          </div>
          <div class="service-info">
            <h3>Büyükbaş / Küçükbaş Hayvan Sigortası</h3>
            <p>Sığır, manda, koyun ve keçi gibi hayvanlarınızı hastalık, kaza ve doğal afetlere karşı sigortalayın. Hayvan ölüm tazminatı ile ekonomik kayıplarınızı minimize edin.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path></svg>
          </div>
          <div class="service-info">
            <h3>Arıcılık (Kovan) Sigortası</h3>
            <p>Arı kovanlarınızı hastalık, zehirlenme, doğal afet ve hırsızlık risklerine karşı sigortalayın. TARSİM kapsamında devlet destekli prim indirimi mevcuttur.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line></svg>
          </div>
          <div class="service-info">
            <h3>Sera Sigortası</h3>
            <p>Seralarınızı ve sera içindeki ürünleri dolu, fırtına, kar yükü ve sel gibi doğal afetlere karşı koruma altına alın.</p>
          </div>
        </div>
      </div>

      <div class="service-cta">
        <h2>Ürünlerinizi ve Hayvanlarınızı Koruma Altına Alın</h2>
        <p>Devlet destekli tarım sigortaları ile riskleri minimize edin. Detaylı bilgi için bize ulaşın.</p>
        <a href="/teklif-al" class="btn-primary">Hemen Teklif Al</a>
      </div>
    </div>
  </section>
`;
